// Hilfs­funktionen zum Laden/Speichern der Settings
const SETTINGS_KEY = 'scannerSettings';

// Fallback‑Defaults, identisch zu public/settings.json
export const defaultSettings = {
    cropping: {
        leftCropPercent: 0.10,
        rightCropPercent: 0.10,
        topCropPercent: 0.00,
        bottomCropPercent: 0.00,
    },
    thresholds: {
        horizontalFactor: 0.70,
        verticalFactor: 0.70,
    },
    camera: {
        deviceId: null, // oder später default: '' o.ä.
    },
};

export function loadSettings() {
    try {
        const raw = localStorage.getItem(SETTINGS_KEY);
        if (!raw) return defaultSettings;
        return { ...defaultSettings, ...JSON.parse(raw) };
    } catch (e) {
        console.error('[settingsService] loadSettings() → Fallback auf Defaults', e);
        return defaultSettings;
    }
}

export function saveSettings(settings) {
    try {
        localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    } catch (e) {
        console.error('[settingsService] saveSettings() fehlgeschlagen', e);
    }
}
